import React, { Component } from "react";
import moment from "moment-timezone";
import Calendar from "react-awesome-calendar";
import Bridge from "../../utils/Bridge";
import "./calender-custom.css";

class SpeechCalenderData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: new Date(),
      calenderdata: [],
      events: [],
      loading: false,
      weekdays: [
        { name: "Sunday", back: 0, front: 6 },
        { name: "Monday", back: 1, front: 5 },
        { name: "Tuesday", back: 2, front: 4 },
        { name: "Wednesday", back: 3, front: 3 },
        { name: "Thursday", back: 4, front: 2 },
        { name: "Friday", back: 5, front: 1 },
        { name: "Saturday", back: 6, front: 0 },
      ],
      months: [
        { name: "Jan", num: 0 },
        { name: "Feb", num: 1 },
        { name: "Mar", num: 2 },
        { name: "Apr", num: 3 },
        { name: "May", num: 4 },
        { name: "Jun", num: 5 },
        { name: "Jul", num: 6 },
        { name: "Aug", num: 7 },
        { name: "Sep", num: 8 },
        { name: "Oct", num: 9 },
        { name: "Nov", num: 10 },
        { name: "Dec", num: 11 },
      ],
      current_month: 0,
      current_year: 0,
      days_in_month: 0,
      active1: false,
      active2: false,
      active3: false,
      active4: false,
      active5: false,
      session_list: [],
      proctored_session_list:[],
    };
    this.calendar = React.createRef();
  }
  componentDidMount() {
    let current_month = moment().format("MMM");
    for (let item of this.state.months) {
      if (item.name == current_month) {
        this.setState({
          current_month: item.num,
          current_year: moment().format("YYYY"),
        });
      }
    }
    let daysInMonth = moment().daysInMonth();
    this.setState(
      {
        days_in_month: daysInMonth,
        calenderdata: this.props.sessions,
      },
      () => this.showcheckboxactive()
    );
    const details = this.calendar.current.getDetails();
    if (this.props.sessions.length > 0) {
      this.setState(
        {
          calenderdata: this.props.sessions,
          session_list: this.props.sessions,
        },
        () => this.setEvents()
      );
    }
  }
  getDatesBetween = (fromDate, toDate) => {
    const dateArray = [];
    let currentDate = new Date(fromDate);

    while (currentDate <= new Date(toDate)) {
      dateArray.push(new Date(currentDate).toISOString().split("T")[0]); // Format as YYYY-MM-DD
      currentDate.setDate(currentDate.getDate() + 1); // Increment date
    }

    return dateArray;
  };

  setEvents = () => {
    let data = this.state.calenderdata;
    let newArr = [];
    let obj = {};
    let count = 1;
    let duplicate = [];
    this.setState({ loading: true });
    
    if (this.state.calenderdata.length > 0) {
      let current_month = this.state.current_month;
      for (let item of this.state.calenderdata) {
        let selecteddate = item.date.split("T")[0];
        let monthname = moment(selecteddate).format("MMM");
        let current_year = moment(selecteddate).format("YYYY");

        let month = 0;
        for (let item of this.state.months) {
          if (item.name == monthname) {
            month = item.num;
          }
        }

        if (current_month == month && this.state.current_year == current_year) {
          
          // =================== Showing selected date ==============================

          let day = moment(selecteddate).format("DD");
          obj = {
            id: count,
            color: "",
            from: `${selecteddate}T00:00:00+00:00`,
            to: `${selecteddate}T00:00:00+00:00`,
            title: `${day}`,
          };
          let to = selecteddate;
          newArr = [...newArr, obj];

          // =================== Showing green line ==============================

          let dayname = moment(selecteddate).format("dddd");
          let back = 0;
          let front = 0;
          for (let item of this.state.weekdays) {
            if (item.name == dayname) {
              back = item.back;
              front = item.front;
            }
          }
          let addeddate = moment(selecteddate)
            .add(front, "days")
            .format("YYYY-MM-DD");
          let subtractdate = moment(selecteddate)
            .subtract(back, "days")
            .format("YYYY-MM-DD");

          let from_month_name = moment(subtractdate).format("MMM");
          let to_month_name = moment(addeddate).format("MMM");
          // if(from_month_name!=to_month_name && (selecteddate>='01' || selecteddate<='07')){

          // }else{
          let to_date = `${addeddate}T19:00:00+00:00`;
          if (!duplicate.includes(to_date)) {
            let obj2 = {
              id: count,
              color: "#6cd300",
              from: `${subtractdate}T18:00:00+00:00`,
              to: `${addeddate}T19:00:00+00:00`,
              title: "",
            };
            let from_date = `${subtractdate}T18:00:00+00:00`;
            newArr.push(obj2);
            duplicate.push(to_date);
          }
          // }
        }

        count++;
      }
      this.setState({ events: newArr, loading: false });
      
      setTimeout(() => {
        let eventtitle = document.querySelectorAll(".eventTitle");
        eventtitle.forEach((item, index) => {
          if (item.innerHTML != "") {
            item.classList.add("speech-selected-date");
          }
        });
      }, 500);
    }
  };
  // show icons active
  showcheckboxactive = () => {
    let daysInMonth = this.state.days_in_month;
    let data = this.state.calenderdata;
    let current_month = this.state.current_month;

    let active1 = false;
    let active2 = false;
    let active3 = false;
    let active4 = false;
    let active5 = false;
    let active6 = false;

    for (let item of data) {
      let selecteddate = item.date.split("T")[0];
      let monthname = moment(selecteddate).format("MMM");
      let current_year = moment(selecteddate).format("YYYY");

      let month = 0;
      for (let item of this.state.months) {
        if (item.name == monthname) {
          month = item.num;
        }
      }

      if (current_month == month && this.state.current_year == current_year) {
        const d = new Date(selecteddate);
        const date = d.getDate();
        const day = d.getDay();
        const weekOfMonth = Math.ceil((date - 1 - day) / 7);

        if (weekOfMonth == "0") {
          active1 = true;
        } else if (weekOfMonth == "1") {
          active2 = true;
        } else if (weekOfMonth == "2") {
          active3 = true;
        } else if (weekOfMonth == "3") {
          active4 = true;
        } else if (weekOfMonth == "4") {
          active5 = true;
        }
      }
    }
    setTimeout(() => {
      this.setState({
        active1,
        active2,
        active3,
        active4,
        active5,
      });
    }, 1000);
  };
  test = (mJsDate) => {
    var str =
      mJsDate.toLocaleString().substring(0, 3) +
      " number " +
      Math.ceil(mJsDate.date() / 7) +
      " of the month";
    return str;
  };
  onChange = (params) => {
    let current_month = params.month;
    let current_year = params.year;
    this.setState(
      { current_month: current_month, current_year: current_year },
      () => this.setEvents()
    );
    /// setting days in month
    let dateval = params.year + "-" + (params.month + 1) + "-" + params.day;
    let daysInMonth = moment(dateval).daysInMonth();
    this.setState({ days_in_month: daysInMonth }, () =>
      this.showcheckboxactive()
    );
  };
  onClickEvent = (event) => {
  };
  render() {
    return (
      <>
        <div className="calender-outer" style={{ height: "100%" }}>
          <div className="row" style={{ marginBottom: 25, paddingTop: 20 }}>
            <div
              className="col-xl-12 col-lg-12 d-flex calender-warpper"
              style={{ paddingLeft: 22 }}
            >
              <br />
              <div
                className="full-calender-wrapper-block"
                style={{ width: "90%" }}
              >
                <Calendar
                  events={this.state.events}
                  ref={this.calendar}
                  onChange={this.onChange}
                  showDay={false}
                  mode={"daily"}
                />
              </div>
              <div className="active_sessions_of_weeks">
                <li>
                  <div
                    className={
                      this.state.active1 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active2 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active3 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active4 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active5 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SpeechCalenderData;
